import React, { useState } from 'react';
import ApiService from '../services/ApiService';
import '../styles/Login.css';

function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await ApiService.login(username, password);
      
      if (!data.success) {
        setError(data.message || 'Ошибка авторизации');
        return;
      }
      
      // Сохраняем токен и данные пользователя в localStorage
      localStorage.setItem('user_token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      
      console.log('✓ Успешная авторизация:', data.user.username);
      
      // Вызываем callback
      onLoginSuccess(data.user);
    } catch (err) {
      console.error('Ошибка при входе:', err);
      setError(err.message || 'Ошибка соединения с сервером');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>KAT-Telecom MAX Messenger</h1>
          <p>Вход в мессенджер</p>
        </div>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Имя пользователя</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Введите имя пользователя"
              disabled={loading}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Пароль</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Введите пароль"
              disabled={loading}
              required
            />
          </div>

          <button
            type="submit"
            className="login-btn"
            disabled={loading}
          >
            {loading ? 'Вход в систему...' : 'Войти'}
          </button>
        </form>

        <div className="login-footer">
          <p>Обратитесь к администратору для получения учетных данных</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
